import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/create-faq.svg'


const _hoisted_1 = { class: "relative bg-white flex flex-col text-12px xxl:text-14px overflow-auto w-full" }
const _hoisted_2 = { class: "font-semibold self-center mr-10 text-20px whitespace-no-wrap text-black-lp-200 capitalize" }
const _hoisted_3 = {
  key: 0,
  class: "border rounded-xl border-gray-lp-1300 pt-4 pb-5 px-4 w-8/12 mt-4"
}
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-16 h-auto cursor-pointer",
    alt: "x"
  })
], -1)
const _hoisted_6 = { class: "w-3/4" }
const _hoisted_7 = { class: "text-14px xxl:text-16px font-bold font-montserrat text-gray-lp-300" }
const _hoisted_8 = { class: "text-12px xxl:text-14px font-normal font-montserrat text-gray-lp-800 pt-1 w-3/4" }
const _hoisted_9 = {
  key: 1,
  class: "flex flex-row justify-between items-center pt-4 pb-1"
}
const _hoisted_10 = { class: "flex flex-row flex-no-wrap items-center relative" }
const _hoisted_11 = { class: "space-y-2 px-2 pb-4" }
const _hoisted_12 = { class: "w-1/2 pl-2.5 py-2 border-r border-gray-lp-400" }
const _hoisted_13 = { class: "w-1/2 pl-2.5 py-2" }
const _hoisted_14 = { class: "flex h-screen justify-center overflow-auto" }
const _hoisted_15 = { class: "overflow-y-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Header = _resolveComponent("Header")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { class: "items-center" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.getTitle), 1),
        (_ctx.isAbleCreate)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 0,
              customClass: "py-2",
              textColor: "white",
              title: _ctx.$t('pickupCorporate.buttonCreateConfig'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/pickup/scheduled-pickup/create')))
            }, null, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_ctx.apiListData.errorType)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("pickupCorporate.bannerScheduleTitle")), 1),
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("pickupCorporate.bannerScheduleDesc")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.apiListData.errorType)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_AdvancedFilter, {
              "custom-max-height": "40vh",
              "model-value": _ctx.filter,
              isDisabled: false,
              onOpened: _ctx.onOpenedAdvancedFilter,
              onReset: _ctx.onResetAdvancedFilter,
              addSumFilter: _ctx.sumFilter
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('pickupCorporate.clientRef')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectSearchV2, {
                        onFilter: _ctx.onSearchClientName,
                        onFocus: _ctx.onSearchClientName,
                        isLoading: _ctx.isLoadingClientPartner,
                        options: _ctx.mappedDataClient,
                        keyName: "name",
                        keyValue: "id",
                        placeholder: _ctx.$t('pickupCorporate.filterPlaceholderClient'),
                        modelValue: _ctx.filter.psClientId,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.psClientId = $event)),
                          _ctx.onSelectClient
                        ],
                        class: "mt-3",
                        isDisabled: _ctx.isClientBranch
                      }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue", "isDisabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('pickupCorporate.vehicleType')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectSearchV2, {
                        onFilter: _ctx.onSearchVehicle,
                        onFocus: _ctx.onSearchVehicle,
                        isLoading: _ctx.isLoadingVehicleList,
                        options: _ctx.vehicles,
                        keyName: "vehicleName",
                        keyValue: "vehicleName",
                        placeholder: _ctx.$t('pickupCorporate.filterPlaceholderVehicle'),
                        modelValue: _ctx.filter.psTransportType,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.psTransportType = $event)),
                          _ctx.onSelectVehicle
                        ],
                        class: "mt-3"
                      }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('pickupCorporate.serviceType')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomDropdown, {
                        class: "mt-3",
                        placeholder: 
                  _ctx.$t('bookingShipment.list.filter.selectServiceType')
                ,
                        value: 
                  _ctx.filter.psServiceCodes.length
                    ? `${_ctx.filter.psServiceCodes.length} ${_ctx.$t(
                        'bookingShipment.list.filter.serviceType'
                      )}`
                    : ''
                
                      }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_12, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productOptions, (product, index) => {
                              return (_openBlock(), _createBlock("div", {
                                key: index,
                                class: "p-field-checkbox mt-1"
                              }, [
                                (index < 5)
                                  ? (_openBlock(), _createBlock(_component_Checkbox, {
                                      key: 0,
                                      name: "product",
                                      id: index,
                                      value: product.code,
                                      modelValue: _ctx.filter.psServiceCodes,
                                      "onUpdate:modelValue": [
                                        _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.psServiceCodes = $event)),
                                        _ctx.onChangeProduct
                                      ]
                                    }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue"]))
                                  : _createCommentVNode("", true),
                                (index < 5)
                                  ? (_openBlock(), _createBlock("label", {
                                      key: 1,
                                      for: index,
                                      class: "ml-2.5"
                                    }, _toDisplayString(product.name), 9, ["for"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _createVNode("div", _hoisted_13, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productOptions, (product, index) => {
                              return (_openBlock(), _createBlock("div", {
                                key: index,
                                class: "p-field-checkbox mt-1.5"
                              }, [
                                (index > 4)
                                  ? (_openBlock(), _createBlock(_component_Checkbox, {
                                      key: 0,
                                      name: "product",
                                      id: index,
                                      value: product.code,
                                      modelValue: _ctx.filter.psServiceCodes,
                                      "onUpdate:modelValue": [
                                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.psServiceCodes = $event)),
                                        _ctx.onChangeProduct
                                      ]
                                    }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue"]))
                                  : _createCommentVNode("", true),
                                (index > 4)
                                  ? (_openBlock(), _createBlock("label", {
                                      key: 1,
                                      for: index,
                                      class: "ml-2.5"
                                    }, _toDisplayString(product.name), 9, ["for"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }, 8, ["placeholder", "value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('pickupCorporate.columnStatus')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomDropdown, {
                        selectedItem: _ctx.filter.psStatus,
                        options: _ctx.statusPickupSchedule,
                        placeholder: _ctx.$t('pickupCorporate.selectStatus'),
                        onSelect: _ctx.selectStatus,
                        class: "mt-3"
                      }, null, 8, ["selectedItem", "options", "placeholder", "onSelect"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _: 1
            }, 8, ["model-value", "onOpened", "onReset", "addSumFilter"])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: "fixed right-0 h-full z-20",
      style: 
        `background-color:rgba(0,0,0,0.3); top: 22rem; width: calc(100% - ${
          _ctx.isAdvancedFilterOpened ? `60px` : `264px`
        });`
      
    }, null, 4), [
      [_vShow, _ctx.isAdvancedFilterOpened]
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_TableV2, {
          loading: _ctx.apiListData.loading,
          borderTop: false,
          borderBottom: false,
          columns: _ctx.columns,
          data: _ctx.listData.data,
          isEmpty: _ctx.isEmpty,
          emptyHeaderMessage: _ctx.$t('pickupCorporate.emptyScheduleHeader'),
          emptyMessage: _ctx.$t('pickupCorporate.emptyScheduleMessage'),
          class: "my-2",
          errorCause: _ctx.apiListData.errorType,
          onClick: _ctx.onClickRow,
          isDetailAble: "",
          pagination: _ctx.listData.pagination,
          "onUpdate:pagination": _cache[6] || (_cache[6] = ($event: any) => (_ctx.listData.pagination = $event)),
          onRequest: _ctx.getPickupScheduleList,
          onTryAgain: _ctx.getPickupScheduleList,
          paginationStyle: "v3",
          totalColumnFreeze: 1,
          isRightFreeze: true,
          isPinnedScrollBottom: ""
        }, null, 8, ["loading", "columns", "data", "isEmpty", "emptyHeaderMessage", "emptyMessage", "errorCause", "onClick", "pagination", "onRequest", "onTryAgain"])
      ])
    ])
  ]))
}